import { render, staticRenderFns } from "./DriversIcon.vue?vue&type=template&id=1c294e96&scoped=true"
var script = {}
import style0 from "./DriversIcon.vue?vue&type=style&index=0&id=1c294e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c294e96",
  null
  
)

export default component.exports